(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play/assets/javascripts/route-play.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play/assets/javascripts/route-play.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  useRouteMatch,
  Switch,
  Route
} = ReactRouterDOM;
const {
  selectSystemTypes
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  GameMenu
} = svs.components.tipsen.gameMenu;
const {
  DrawManager
} = svs.components.tipsen.drawManager;
const {
  tipsenLazy
} = svs.components.tipsen.tipsenLazy;
const {
  WalletHandler,
  NoDraws,
  ClientErrorReport,
  MarketplaceWagerPaid
} = svs.components.tipsen.routePlay;
const {
  CenterToScreen
} = svs.components.tipsen.centerToScreen;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  useEffect,
  useContext
} = React;
const {
  EngineProviderContext
} = svs.components.tipsen.engine;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const {
  userSession
} = svs.core;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  selectCurrentDrawsByProduct
} = svs.components.tipsen.selectors;
const {
  loadOpenedDrawsByEngine
} = svs.components.sport.drawsRedux.actions;
const {
  DrawProvider
} = svs.components.tipsen.drawProvider;
const {
  getCompetitionFactoryInstance
} = svs.components.tipsen.competition.competitionFactoryInstance;
const {
  TemplateBrand
} = svs.components.tipsen.setBranding;
const {
  useGetCompetitionStatus
} = svs.components.tipsen.hooks;
const {
  useCompetitionModeForPath,
  useIsCompetitionInCurrentProduct
} = svs.components.marketplaceCompetition.services.hooks;
const {
  fetchPlayerCompetitions
} = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions;
const {
  selectPlayerCompetition
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  CompetitionSubscription
} = svs.components.marketplaceCompetition.competitionSubscription;
const {
  competitionHandler
} = svs.components.marketplaceCompetition.competitionHandler;
const {
  FetchVideoAnalyses,
  RoutePlaySpelaFallback,
  RoutePlayPixFallback,
  RoutePlaySinglesFallback
} = svs.components.tipsen.routePlay;
const {
  SportinfoPathNames
} = svs.components.sportinfo.common.constants;
const {
  useAssistedFocusScroll
} = svs.components.lbUtils.assistedFocusScroll;
const LazyPlay = tipsenLazy('/cl/tipsen/route-play-spela', () => svs.components.tipsen.routePlaySpela.RoutePlaySpela, {
  fallback: RoutePlaySpelaFallback
});
const LazyPlayPix = tipsenLazy('/cl/tipsen/route-play-pix', () => svs.components.tipsen.RoutePlayPix, {
  fallback: RoutePlayPixFallback
});
const LazySpelaMarketplace = tipsenLazy('/cl/tipsen/route-play-marketplace', () => svs.components.tipsen.RoutePlayMarketplace);
const LazySpelaSingles = tipsenLazy('/cl/tipsen/route-play-singles', () => svs.components.tipsen.routePlaySingles.RoutePlaySingles, {
  fallback: RoutePlaySinglesFallback
});
const LazySpelaExternal = tipsenLazy('/cl/tipsen/route-play-external', () => svs.components.tipsen.RoutePlayExternal.RoutePlayExternal);
const LazySpelaExternalInspect = tipsenLazy('/cl/tipsen/route-play-external-inspect', () => svs.components.tipsen.routePlayExternalInspect.RoutePlayExternalInspect);
const CampaignWrapper = () => {
  const [productBranding] = useBranding();
  return React.createElement(CampaignFlerp, {
    branding: productBranding
  });
};
const isRetailer = userSession.hasRole(userSession.roles.RETAILER);
const hasExternal = !isSelfService && !isRetailer;
const competitionPaths = ["/".concat(TipsenModuleGameUrl.TIPS_SM), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.YOUR_COUPON), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.News), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Table), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Statistic), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Lineup), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Analyze), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.MatchInfo), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Mutuals), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Events), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.PlayMakerXstat), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_SM), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_SM, "/resultat"), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_SM, "/om"), "/".concat(TipsenModuleGameUrl.TIPS_EM), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.YOUR_COUPON), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.News), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Table), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Statistic), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Lineup), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Analyze), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.MatchInfo), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Mutuals), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Events), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.PlayMakerXstat), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_EM), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_EM, "/resultat"), "/tavlingar/".concat(TipsenModuleGameUrl.TIPS_EM, "/om")];
const clientErrors = svs.tipsen.data.clientErrors;
const hasClientErrors = Array.isArray(clientErrors) && clientErrors.length > 0;
const RoutePlay = () => {
  var _competitionHandler$g, _competitionHandler, _currentCompetition$d;
  const {
    useCompetition
  } = getCompetitionFactoryInstance().getCompetitionHooksForCms();
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const isFeatureVideoAnalysesEnabled = currentEngine.brandName === 'stryktipset' && svs.core.detect.feature('ft-pool-betting-video-analyses');
  const match = useRouteMatch();
  const supportsSystems = useSelector(selectSystemTypes).length > 1;
  const competitionId = (_competitionHandler$g = (_competitionHandler = competitionHandler()) === null || _competitionHandler === void 0 || (_competitionHandler = _competitionHandler.getActiveCompetition(currentEngine.drawProductIds[0])) === null || _competitionHandler === void 0 ? void 0 : _competitionHandler.getCompetitionId()) !== null && _competitionHandler$g !== void 0 ? _competitionHandler$g : undefined;
  const currentCompetition = useCompetition(competitionId, currentEngine);
  const showCompetition = Boolean(currentCompetition);
  const competitionStatus = useGetCompetitionStatus(currentEngine, competitionId);
  useCompetitionModeForPath(competitionId, currentEngine.drawProductIds, competitionPaths, competitionStatus);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadOpenedDrawsByEngine(currentEngine));
  }, [dispatch, currentEngine]);
  const isCompetitionInCurrentProduct = useIsCompetitionInCurrentProduct(currentCompetition === null || currentCompetition === void 0 || (_currentCompetition$d = currentCompetition.details) === null || _currentCompetition$d === void 0 ? void 0 : _currentCompetition$d.productId, currentEngine === null || currentEngine === void 0 ? void 0 : currentEngine.drawProductIds);
  const playerCompetition = useSelector(state => selectPlayerCompetition(state));
  const signUpsCompetitions = playerCompetition.signUps.competitions;
  const hasSignUpsCompetitions = Object.keys(signUpsCompetitions).length > 0;
  const isActiveOnly = true;
  useEffect(() => {
    if (isCompetitionInCurrentProduct && !hasSignUpsCompetitions && !isSelfService) {
      dispatch(fetchPlayerCompetitions({
        isActiveOnly
      }));
    }
  }, [isCompetitionInCurrentProduct, hasSignUpsCompetitions, competitionId, isActiveOnly, dispatch]);
  const draws = useSelector(selectCurrentDrawsByProduct);
  const assistedFocusContainerRef = useAssistedFocusScroll({
    offsetTop: 150,
    offsetBottom: 85
  });
  if (draws.length === 0) {
    return React.createElement(React.Fragment, null, React.createElement(CampaignWrapper, null), React.createElement("main", null, hasClientErrors && React.createElement(ClientErrorReport, {
      clientErrors: clientErrors
    }), React.createElement(NoDraws, null)));
  }
  return React.createElement(DrawProvider, null, React.createElement(CompetitionSubscription, {
    competitionId: competitionId
  }), React.createElement(CampaignWrapper, null), React.createElement(TemplateBrand, null), React.createElement(WalletHandler, null), React.createElement("main", {
    ref: assistedFocusContainerRef
  }, React.createElement(MarketplaceWagerPaid, null), isFeatureVideoAnalysesEnabled && React.createElement(FetchVideoAnalyses, null), hasClientErrors && React.createElement(ClientErrorReport, {
    clientErrors: clientErrors
  }), React.createElement(CenterToScreen, null, React.createElement(ErrorBoundary, {
    fallback: () => null
  }, React.createElement("section", {
    "aria-label": "Omg\xE5ng"
  }, React.createElement(DrawManager, null))), React.createElement("h2", {
    className: "tipsen-header f-center f-medium",
    id: "game-menu-heading"
  }, "Hur vill du spela?"), React.createElement(GameMenu, null)), React.createElement(Switch, null, supportsSystems && React.createElement(Route, {
    path: "".concat(match.path).concat(TipsenModuleGameUrl.SYSTEM)
    ,
    render: () => React.createElement(LazyPlay, {
      match: match
    })
  }), showCompetition && React.createElement(Route, {
    path: ["".concat(match.path).concat(TipsenModuleGameUrl.TIPS_SM), "".concat(match.path).concat(TipsenModuleGameUrl.TIPS_EM)]
    ,
    render: () => React.createElement(LazyPlay, {
      match: match
    })
  }), React.createElement(Route, {
    component: LazyPlayPix,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.PIX)
  }), !isSelfService && React.createElement(Route, {
    component: LazySpelaMarketplace,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.MARKETPLACE)
  }), React.createElement(Route, {
    component: LazySpelaSingles,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.SINGLES)
  }), hasExternal && React.createElement(Route, {
    component: LazySpelaExternal,
    exact: true,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.EXTERNAL)
  }), hasExternal && React.createElement(Route, {
    component: LazySpelaExternalInspect,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.EXTERNAL, "/granska/:guid")
  }), React.createElement(Route
  , {
    render: () => React.createElement(LazyPlay, {
      match: match
    })
  }))));
};
setGlobal('svs.components.tipsen.routePlay.RoutePlay', RoutePlay);

 })(window);